import {staticPagesActionTypes} from "../constants/ActionTypes";

const initialState = {
  staticPages: [],
  pageTypes: [],
  page: null
};

const staticPages = (state = initialState, action) => {
  switch (action.type) {
    case staticPagesActionTypes.GET_STATIC_PAGES:
      return {
        ...state,
        staticPages: action.staticPages,
      };
    case staticPagesActionTypes.GET_PAGE_TYPES:
      return {
        ...state,
        pageTypes: action.pageTypes
      };
    case staticPagesActionTypes.GET_PAGE:
      return {
        ...state,
        page: action.page
      };
  }

  return state;
};

export default staticPages;



// WEBPACK FOOTER //
// ./reducers/staticPages.reducers.js